import { LogisticCartStatus } from 'models/logistic_cart'

export const LOGISTIC_CART_STATUS_TEXT: Record<LogisticCartStatus, string> = {
  [LogisticCartStatus.in_process]: 'В работе',
  [LogisticCartStatus.error]: 'На уточнении',
  [LogisticCartStatus.waiting]: 'В ожидании',
  [LogisticCartStatus.given]: 'Закрыто',
  [LogisticCartStatus.denied]: 'Отклонено',
}
